// extracted by mini-css-extract-plugin
module.exports = {"main":"CloseButton_main__30YJf"};